import { CanActivateFn, Router, UrlTree } from '@angular/router';
import { inject } from '@angular/core';
import { AuthService } from './auth.service';

export const authGuard: CanActivateFn = (): boolean | UrlTree => {
  const auth = inject(AuthService);
  const router = inject(Router);

  const token = auth.readToken();
  if (!token) return router.createUrlTree(['/login']);

  // token présent mais expiré → purge + redir
  if (auth.isTokenExpired(token)) {
    auth.logout(true);
    return router.createUrlTree(['/login'], { queryParams: { expired: '1' } });
  }

  return true; // OK
};
